import { render } from "./CompetitionRounds.vue?vue&type=template&id=390454b8&scoped=true"
import script from "./CompetitionRounds.vue?vue&type=script&lang=js"
export * from "./CompetitionRounds.vue?vue&type=script&lang=js"

import "./CompetitionRounds.vue?vue&type=style&index=0&id=390454b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-390454b8"]])

export default __exports__